// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/flag-icons/css/flag-icons.min.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.padlock-container {
  position: relative;
}

.padlock {
  display: none;
}

.padlock.disabled {
  display: block;
}

.card-row.disabled {
  opacity: 0.25; /* Makes the card look disabled */
  background-color: #e7e7e7; /* Light grey background color */
  color: #4c4c47; /* Grey text color */
}
.card-row.disabled .card-details h2,
.card-row.disabled .card-details div {
  color: #4c4c47; /* Grey text color for details */
}
.card-row.disabled .card-arrow, .card-row.disabled .card-download mat-icon {
  color: #ccc; /* Grey icon color */
}
.card-row.disabled:hover {
  background-color: #666660;
  color: white;
}
.card-row.disabled:hover .card-details h2,
.card-row.disabled:hover .card-details div {
  color: white;
}
.card-row.disabled:hover .card-arrow, .card-row.disabled:hover .card-download mat-icon {
  color: #ccc;
}

.card-row {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  margin: 10px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
}
.card-row .header-container h2:hover,
.card-row .card-details h2:hover,
.card-row .card-details:hover {
  background-color: #AACCFF;
  color: #2D2D2A;
  border-radius: 5px;
}
.card-row:active {
  background-color: #0CAD99;
}
@media (max-width: 768px) {
  .card-row {
    flex-direction: column;
    align-items: flex-start;
  }
}

.card-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  width: 110px;
  flex-shrink: 0;
}
.card-logo img {
  max-width: 100px; /* Adjust as needed */
  height: auto;
  max-height: 50px; /* Adjust to ensure proper aspect ratio */
  object-fit: contain;
}

.rdna-flag-img {
  min-width: 125px;
  max-width: 200px; /* Adjust as needed */
  height: auto;
  max-height: 60px; /* Adjust to ensure proper aspect ratio */
  object-fit: contain;
}

.flag-icon {
  width: 125px; /* Adjust as needed */
  height: 50px;
}

.sm-flag-icon {
  width: 30px; /* Adjust as needed */
  height: 15px;
}

.card-details {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0; /* Ensures the flex item doesn't shrink below its contents */
}
.card-details .header-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap; /* Ensure the header text wraps */
  justify-content: space-between; /* Space items evenly */
  width: 100%; /* Ensure it takes full width */
}
.card-details .header-container .header-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap; /* Ensure the header text wraps */
}
.card-details .header-container .header-left h2 {
  margin: 0 10px 0 0;
  font-size: 1.5em;
  color: #2D2D2A;
  transition: color 0.3s ease;
  word-wrap: break-word; /* Allows long words to wrap */
  flex: 1 1 auto; /* Allows the h2 to grow and shrink */
  min-width: 0; /* Ensures the flex item doesn't shrink below its contents */
  /* Ensure color change on parent hover */
}
.card-details .header-container .header-left .heart-icon-outline {
  font-size: 1.5em;
  color: #0CAD99;
  cursor: pointer;
  margin-right: 10px;
  transition: color 0.3s ease;
}
.card-details .header-container .header-left .heart-icon-outline:hover {
  color: #0CAD99;
}
.card-details .header-container .header-left .heart-icon {
  display: none;
  font-size: 1.5em;
  color: #0CAD99;
  cursor: pointer;
  margin-right: 10px;
}
.card-details .header-container .header-left:hover .heart-icon-outline {
  display: none;
}
.card-details .header-container .header-left:hover .heart-icon {
  display: inline-block;
}
.card-details .header-container .header-right {
  display: flex;
  align-items: center;
}
.card-details .header-container .header-right span {
  margin-left: 10px;
  font-size: 1em;
}
.card-details .button-container {
  display: flex;
  flex-wrap: wrap; /* Ensure buttons wrap when overflowing */
  align-items: center; /* Align items in the center */
  margin-top: 5px;
}
.card-details .button-container div {
  font-size: 0.9em; /* Smaller text for "Ranked in" */
  margin-right: 10px; /* Space between "Ranked in" and buttons */
}
.card-details .button-container button {
  background-color: white;
  border: 2px solid #0CAD99;
  padding: 5px 10px; /* Small padding */
  color: #0CAD99;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  margin: 5px 5px 5px 0; /* Space between buttons */
}
.card-details .button-container button:hover {
  background-color: #0CAD99;
  color: white; /* Change text color to white for better contrast */
}
.card-details .button-container button:disabled {
  background-color: #fff; /* Change to your desired disabled background color */
  border: 2px solid #4c4c47; /* Change to your desired disabled border color */
  color: #4c4c47; /* Change to your desired disabled text color */
  cursor: not-allowed; /* Change cursor to indicate disabled state */
  opacity: 0.6; /* Optional: make the button slightly transparent */
}

.disabled-button {
  border-color: #ccc !important;
  color: #ccc !important;
  background-color: white !important;
}

.card-arrow, .card-download {
  display: flex;
  align-items: center; /* Center the chevron vertically */
  margin-left: auto; /* Push the arrow to the right */
  margin-right: 10px;
}
.card-arrow mat-icon, .card-download mat-icon {
  font-size: 24px;
  color: #2D2D2A;
  transition: color 0.3s ease;
}

.spacer {
  flex-grow: 1;
}

.material-symbols-outlined:hover {
  color: #0CAD99;
}

@media (max-width: 768px) {
  .card-row {
    align-items: center;
    padding: 0 10px 0 10px;
  }
  .card-logo {
    width: 150px;
    margin-right: 0px;
  }
  .header-left {
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    flex-wrap: wrap; /* Ensure the header text wraps */
  }
  .header-left h2 {
    margin: 5px 0 10px 0 !important;
    font-size: 18px !important;
    flex: none !important; /* Allows the h2 to grow and shrink */
  }
  p {
    font-size: 12px;
  }
  .header-container {
    width: 100%;
  }
  .button-container {
    flex-direction: column;
    margin-top: 10px;
  }
  .list-name {
    display: none;
  }
  .sm-flag-icon {
    display: none;
  }
  .card-arrow {
    display: none;
  }
  img {
    height: 70px;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./src/app/explore/card/card.component.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss"],"names":[],"mappings":"AAAA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;ACCF;ADCE;EACE,4BAAA;ACCJ;ADCI;EACE,YAAA;ACCN;;AFbA,sBAAA;AGME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;ADWJ;ACRM;EACE,sHAAA;ADUR;ACNI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;ADQN;ACLI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;ADON;ACJI;EACE,mBAAA;EACA,sBAAA;ADMN;;ACCE;EACE,qCAAA;ADEJ;ACCE;EACE,0BAAA;ADCJ;;ACKE;EACE,0BAAA;ADFJ;ACKE;EACE,uFAAA;ADHJ;;AE1DA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;AF2DA;;AExDA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AF2DJ;;AEvDA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;AFwDJ;;AEnDA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;AFoBR;;AEdA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;AFyEb;;AEZA;EAAa,YAAA;AFgBb;;AEfA;EAAO,SAAA;EAAW,iDAAA;AFoBlB;;AEjBA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AFkBJ;AEhBI;EACI,YAAA;EACA,SAAA;AFkBR;;AEfA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AFkBF;;AEfA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AFkBF;;AEfA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AFkGb;AEhBI;EACI,cAnFK;AFqGb;;AEdA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;AF6Ff;AEfE;EACE,cA/EW;AFgGf;;AEbA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AFgBJ;;AGpKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHuKF;AGpKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AHsKF;AGnKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHqKF;AGlKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AHoKF;AGjKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHmKF;AGhKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AHkKF;AG/JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHiKF;AG9JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHgKF;AG7JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AH+JF;AG5JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AH8JF;AG3JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AH6JF;AG1JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH4JF;AGzJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AH2JF;AGxJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AH0JF;AGvJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHyJF;AGtJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AHwJF;AGrJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AHuJF;AGpJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHsJF;AI1QA;;;;;uBAAA;ADPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHyRF;AGtRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AHwRF;AGrRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHuRF;AGpRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AHsRF;AGnRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHqRF;AGlRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AHoRF;AGjRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHmRF;AGhRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHkRF;AG/QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHiRF;AG9QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AHgRF;AG7QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AH+QF;AG5QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH8QF;AG3QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AH6QF;AG1QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AH4QF;AGzQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AH2QF;AGxQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AH0QF;AGvQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AHyQF;AGtQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHwQF;AI5XA;;;;;uBAAA;AJCA;EACE,kBAAA;AAmYF;;AA/XA;EACE,aAAA;AAkYF;;AA/XA;EACE,cAAA;AAkYF;;AA/XA;EACE,aAAA,EAAA,iCAAA;EAEA,yBE2CgB,EF3CoB,gCAAA;EACpC,cEyCiB,EFzCS,oBAAA;AAiY5B;AA/XE;;EAEE,cEqCe,EFrCW,gCAAA;AAiY9B;AA9XE;EACE,WAAA,EAAA,oBAAA;AAgYJ;AA7XE;EACE,yBAAA;EACA,YAAA;AA+XJ;AA7XI;;EAEE,YAAA;AA+XN;AA5XI;EACE,WAAA;AA8XN;;AAzXA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,wCAAA;EACA,uDAAA;EACA,eAAA;AA4XF;AApXM;;;EACE,yBI7CE;EJ8CF,cEhCK;EFiCL,kBAAA;AAwXR;AAhXE;EACE,yBI1Da;AJ4ajB;AA/WE;EA/BF;IAgCI,sBAAA;IACA,uBAAA;EAkXF;AACF;;AA/WA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AAkXF;AAhXE;EACE,gBAAA,EAAA,qBAAA;EACA,YAAA;EACA,gBAAA,EAAA,yCAAA;EACA,mBAAA;AAkXJ;;AA9WA;EACE,gBAAA;EACA,gBAAA,EAAA,qBAAA;EACA,YAAA;EACA,gBAAA,EAAA,yCAAA;EACA,mBAAA;AAiXF;;AA9WA;EACE,YAAA,EAAA,qBAAA;EACA,YAAA;AAiXF;;AA9WA;EACE,WAAA,EAAA,qBAAA;EACA,YAAA;AAiXF;;AA9WA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA,EAAA,4DAAA;AAiXF;AA/WE;EACE,aAAA;EACA,mBAAA;EACA,eAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,uBAAA;EACA,WAAA,EAAA,+BAAA;AAiXJ;AA/WI;EACE,aAAA;EACA,mBAAA;EACA,eAAA,EAAA,iCAAA;AAiXN;AA5WM;EACE,kBAAA;EACA,gBAAA;EACA,cE7GK;EF8GL,2BAAA;EACA,qBAAA,EAAA,8BAAA;EACA,cAAA,EAAA,qCAAA;EACA,YAAA,EAAA,4DAAA;EAEA,wCAAA;AA6WR;AAvWM;EACE,gBAAA;EACA,cI3IS;EJ4IT,eAAA;EACA,kBAAA;EACA,2BAAA;AAyWR;AAvWQ;EACE,cIjJO;AJ0fjB;AArWM;EACE,aAAA;EACA,gBAAA;EACA,cIxJS;EJyJT,eAAA;EACA,kBAAA;AAuWR;AApWM;EACE,aAAA;AAsWR;AAnWM;EACE,qBAAA;AAqWR;AAjWI;EACE,aAAA;EACA,mBAAA;AAmWN;AAjWM;EACE,iBAAA;EACA,cAAA;AAmWR;AA9VE;EACE,aAAA;EACA,eAAA,EAAA,yCAAA;EACA,mBAAA,EAAA,8BAAA;EACA,eAAA;AAgWJ;AA9VI;EACE,gBAAA,EAAA,iCAAA;EACA,kBAAA,EAAA,0CAAA;AAgWN;AA7VI;EACE,uBAAA;EACA,yBAAA;EACA,iBAAA,EAAA,kBAAA;EACA,cIhMW;EJiMX,eAAA;EACA,kBAAA;EACA,sCAAA;EACA,qBAAA,EAAA,0BAAA;AA+VN;AA7VM;EACE,yBIvMS;EJwMT,YAAA,EAAA,mDAAA;AA+VR;AA5VM;EACE,sBAAA,EAAA,qDAAA;EACA,yBAAA,EAAA,iDAAA;EACA,cEjKW,EFiKe,+CAAA;EAC1B,mBAAA,EAAA,6CAAA;EACA,YAAA,EAAA,mDAAA;AA8VR;;AAxVA;EACE,6BAAA;EACA,sBAAA;EACA,kCAAA;AA2VF;;AAtVA;EACE,aAAA;EACA,mBAAA,EAAA,kCAAA;EACA,iBAAA,EAAA,gCAAA;EACA,kBAAA;AAyVF;AAvVE;EACE,eAAA;EACA,cEtNS;EFuNT,2BAAA;AAyVJ;;AArVA;EACE,YAAA;AAwVF;;AArVA;EACE,cIhPe;AJwkBjB;;AArVA;EAEE;IACE,mBAAA;IACA,sBAAA;EAuVF;EArVA;IAEE,YAAA;IACE,iBAAA;EAsVJ;EAjVC;IACC,sBAAA;IACA,wBAAA;IACA,kCAAA;IACA,eAAA,EAAA,iCAAA;EAmVF;EAjVE;IACE,+BAAA;IACA,0BAAA;IACA,qBAAA,EAAA,qCAAA;EAmVJ;EA3UE;IACE,eAAA;EA6UJ;EAzUA;IACI,WAAA;EA2UJ;EAzUE;IACE,sBAAA;IACA,gBAAA;EA2UJ;EAxUD;IACC,aAAA;EA0UA;EAxUD;IACC,aAAA;EA0UA;EAxUA;IACE,aAAA;EA0UF;EAxUE;IACA,YAAA;EA0UF;AACF","sourcesContent":["/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import '/src/styles.scss';\n@import \"/node_modules/flag-icons/css/flag-icons.min.css\";\n@import \"placeholders/flexboxes\";\n@import \"placeholders/fonts\";\n@import \"placeholders/quickStyles\";\n@import \"variables/breakpoints\";\n@import \"variables\";\n\n.padlock-container{\n  position:relative\n}\n\n\n.padlock{\n  display:none\n}\n\n.padlock.disabled{\n  display:block\n}\n\n.card-row.disabled {\n  opacity: 0.25; /* Makes the card look disabled */\n  // pointer-events: none; /* Prevents any interaction */\n  background-color: $theme-lightgray; /* Light grey background color */\n  color: $theme-back-light; /* Grey text color */\n\n  .card-details h2,\n  .card-details div {\n    color: $theme-back-light; /* Grey text color for details */\n  }\n\n  .card-arrow, .card-download mat-icon {\n    color: #ccc; /* Grey icon color */\n  }\n\n  &:hover {\n    background-color: lighten($theme-back-light, 10%);\n    color: white;\n\n    .card-details h2,\n    .card-details div {\n      color: white;\n    }\n\n    .card-arrow, .card-download mat-icon {\n      color: #ccc;\n    }\n  }\n}\n\n.card-row {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-radius: 5px;\n  margin: 10px 0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n\n\n\n    .header-container h2,\n    .card-details h2,\n    .card-details {\n      //color: white !important; /* Ensure color change on hover */\n      &:hover {\n        background-color: $theme-2;\n        color: $theme-back;\n        border-radius: 5px;\n    }\n\n    .card-arrow, .card-download mat-icon {\n      //color: white;\n    }\n  }\n\n  &:active {\n    background-color: $theme-contrast;\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.card-logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 15px;\n  width: 110px;\n  flex-shrink: 0;\n\n  img {\n    max-width: 100px; /* Adjust as needed */\n    height: auto;\n    max-height: 50px; /* Adjust to ensure proper aspect ratio */\n    object-fit: contain;\n  }\n}\n\n.rdna-flag-img {\n  min-width: 125px;\n  max-width: 200px; /* Adjust as needed */\n  height: auto;\n  max-height: 60px; /* Adjust to ensure proper aspect ratio */\n  object-fit: contain;\n}\n\n.flag-icon {\n  width: 125px; /* Adjust as needed */\n  height: 50px;\n}\n\n.sm-flag-icon {\n  width: 30px; /* Adjust as needed */\n  height: 15px;\n}\n\n.card-details {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  min-width: 0; /* Ensures the flex item doesn't shrink below its contents */\n\n  .header-container {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap; /* Ensure the header text wraps */\n    justify-content: space-between; /* Space items evenly */\n    width: 100%; /* Ensure it takes full width */\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap; /* Ensure the header text wraps */\n      &:hover {\n        //color: #fff;\n      }\n\n      h2 {\n        margin: 0 10px 0 0;\n        font-size: 1.5em;\n        color: $theme-back;\n        transition: color 0.3s ease;\n        word-wrap: break-word; /* Allows long words to wrap */\n        flex: 1 1 auto; /* Allows the h2 to grow and shrink */\n        min-width: 0; /* Ensures the flex item doesn't shrink below its contents */\n\n        /* Ensure color change on parent hover */\n        .card-row:hover & {\n          //color: white;\n        }\n      }\n\n      .heart-icon-outline {\n        font-size: 1.5em;\n        color: $theme-contrast;\n        cursor: pointer;\n        margin-right: 10px;\n        transition: color 0.3s ease;\n\n        &:hover {\n          color: $theme-contrast;\n        }\n      }\n\n      .heart-icon {\n        display: none;\n        font-size: 1.5em;\n        color: $theme-contrast;\n        cursor: pointer;\n        margin-right: 10px;\n      }\n\n      &:hover .heart-icon-outline {\n        display: none;\n      }\n\n      &:hover .heart-icon {\n        display: inline-block;\n      }\n    }\n\n    .header-right {\n      display: flex;\n      align-items: center;\n\n      span {\n        margin-left: 10px;\n        font-size: 1em;\n      }\n    }\n  }\n\n  .button-container {\n    display: flex;\n    flex-wrap: wrap; /* Ensure buttons wrap when overflowing */\n    align-items: center; /* Align items in the center */\n    margin-top: 5px;\n\n    div {\n      font-size: 0.9em; /* Smaller text for \"Ranked in\" */\n      margin-right: 10px; /* Space between \"Ranked in\" and buttons */\n    }\n\n    button {\n      background-color: white;\n      border: 2px solid $theme-contrast;\n      padding: 5px 10px; /* Small padding */\n      color: $theme-contrast;\n      cursor: pointer;\n      border-radius: 5px;\n      transition: background-color 0.3s ease;\n      margin: 5px 5px 5px 0; /* Space between buttons */\n\n      &:hover {\n        background-color: $theme-contrast;\n        color: white; /* Change text color to white for better contrast */\n      }\n\n      &:disabled {\n        background-color: #fff; /* Change to your desired disabled background color */\n        border: 2px solid $theme-back-light; /* Change to your desired disabled border color */\n        color: $theme-back-light; /* Change to your desired disabled text color */\n        cursor: not-allowed; /* Change cursor to indicate disabled state */\n        opacity: 0.6; /* Optional: make the button slightly transparent */\n      }\n    }\n  }\n}\n\n.disabled-button {\n  border-color: #ccc !important;\n  color: #ccc !important;\n  background-color: white !important;\n\n}\n\n\n.card-arrow, .card-download {\n  display: flex;\n  align-items: center; /* Center the chevron vertically */\n  margin-left: auto; /* Push the arrow to the right */\n  margin-right: 10px;\n\n  mat-icon {\n    font-size: 24px;\n    color: $theme-back;\n    transition: color 0.3s ease;\n  }\n}\n\n.spacer {\n  flex-grow: 1;\n}\n\n.material-symbols-outlined:hover {\n  color: $theme-contrast;\n}\n\n@media (max-width: 768px) {\n\n  .card-row{\n    align-items: center;\n    padding: 0 10px 0 10px\n  }\n  .card-logo {\n\n    width: 150px;\n      margin-right: 0px;\n\n  }\n\n\n   .header-left {\n    width:100% !important;\n    display: flex !important;\n    justify-content: center !important;\n    flex-wrap: wrap; /* Ensure the header text wraps */\n\n    h2 {\n      margin: 5px 0 10px 0 !important;\n      font-size: 18px !important;\n      flex: none !important; /* Allows the h2 to grow and shrink */\n\n\n\n    }\n  }\n\n\n    p{\n      font-size:12px\n\n    }\n\n  .header-container{\n      width:100%\n    }\n    .button-container {\n      flex-direction:column;\n      margin-top: 10px;\n\n    }\n .list-name{\n  display:none\n }\n .sm-flag-icon{\n  display:none\n }\n  .card-arrow{\n    display:none\n  }\n    img {\n    height: 70px;\n    }\n  }\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
